import React, { Component } from 'react';
import { Parallax } from "react-parallax";

export class Faqs extends Component {
    componentDidMount() {
        window.scrollTo(0, 0)
    }
    render() {
        return (
            <section id="faqs">
                <Parallax blur={4} bgImage="../img/parallax-bg-4.jpg" strength={500} className="parallax-display">
                    <div className="w-100" style={{ height: 500, width: 100 }} />
                    <div className="parallax-box">Freqently Asked Questions</div>
                </Parallax>
                <div className="p-5 body-lt">
                    <h2>FAQs</h2>
                    <ol>
                        <li className="list-bold">How do I favorite a program?</li>
                        <p>
                            First, check that you are logged in. You must be logged in to favorite any programs.
                            Once logged in, on the homepage or under "Program &amp; Events" in the navigation bar,
                            all cards listed under "Programs" should have a green button with a heart in the center
                            next to the "View Details" button.
                        </p>
                        <li className="list-bold">How do I view the events that I have saved?</li>
                        <p>
                            Make sure you are signed in. Once you have signed in, click on your name in the upper
                            right corner of the page. A drop down menu will appear and the first option should be
                            "My Page". Click on "My Page" to see your favorited events.
                        </p>
                        <li className="list-bold">Why can't I favorite an event?</li>
                        <p>Events are unable to be saved. Our favoriting system is directed towards saving information
                            of potential programs for our users. Some suggestions if you would like to save an event are:
                        </p>
                        <ul>
                            <li>Bookmark to internet browser</li>
                            <li>Write it down in a physicial or digital planner</li>
                            <li>Keep tabs on the Facebook page or website of the event that you're interested in!</li>
                        </ul>
                        <li className="list-bold">How can I ask questions about a program?</li>
                        <p>
                            Under "view details" for each program, you will be able to find the organizer's contact information.
                            Simply send them an email if there are any inquires and they will get back to you.
                        </p>

                        <li className="list-bold">What is the difference between "Sign In as Organization" and "Sign In as Member"?</li>
                        <p>
                            Organization accounts are specifically reserved for properly vetted organizations. Organization accounts
                            contribute to SpeNeeds and the community by adding their program and events to the application. They also
                            have the ability to answer any questions that members may have or have asked through SpeNeed's Q&amp;A.
                        </p>
                        <p>
                            Member accounts are for general members of the community, such as those who may be particiants of the programs
                            or their family members who can help them search and resgister for a program. Members are able to favorite their
                            programs of interest, but can also take a look at upcoming events, which may be of interest.
                        </p>
                    </ol>
                </div>
            </section>
        );
    }
}